<template>
  <v-col cols="3">
    <v-skeleton-loader
      :loading="collectionPointLoading"
      :types="skeleton"
      type="list-item-three-line"
      class="mb-6"
      min-height="160"
    >
      <v-card class="elevation-12">
        <RequestsMenu
          :collectionPoint="collectionPoint"
          :routeType="routeType"
        />
      </v-card>
    </v-skeleton-loader>

    <v-card class="elevation-12 right-side-ean">
      <v-card-text class="px-3 py-2 pb-4">
        <div class="text-h5 primary--text text-center font-weight-regular mt-2">
          Jiné odběrné místo
        </div>

        <SearchEAN
          label=""
          :detailSearch="true"
          @searchInstallation="searchInstallation"
          @installationLoading="installationLoading"
          :eanErrorMessage="eanErrorMessage"
          :searchEanLoading="collectionPointLoading"
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import RequestsMenu from '@/components/RequestsMenu.vue';
import SearchEAN from '@/components/utils/SearchEAN.vue';

export default {
  name: 'CollectionPointRightSideCards',
  components: {
    RequestsMenu,
    SearchEAN,
  },
  props: {
    collectionPoint: {
      type: Object,
      required: false,
    },
    collectionPointLoading: {
      type: Boolean,
      default: false,
      required: false,
    },
    eanErrorMessage: {
      type: String,
      default: null,
      required: false,
    },
    routeType: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      skeleton: {
        'list-item-three-line': 'paragraph',
      },
    };
  },
  methods: {
    installationLoading(loading) {
      this.$emit('installationLoading', loading);
    },
    searchInstallation(ean) {
      this.$emit('searchInstallation', ean);
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-card.right-side-ean {
  background: #e7ebf4;
}

.theme--light.v-card.right-side-ean .v-input__slot {
  background: #fff;
}
</style>
